import { IconSpinner } from "@tine/designsystem-icons/sharp";
import { cn } from "@tine/designsystem-utils";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";

import Modal from "./Modal";

interface LoadingProps {
   simple?: boolean;
   modal?: boolean;
   label?: string | null;
   className?: string;
   delay?: boolean;
}

const Loading = ({ simple = false, modal = false, label = null, className = "", delay = true }: LoadingProps) => {
   const [isVisible, setVisible] = useState(!delay);

   useEffect(() => {
      if (!delay) {
         return;
      }

      const timerId = setTimeout(() => {
         setVisible(true);
      }, 150);

      return () => {
         clearTimeout(timerId);
      };
   }, [delay]);

   if (!isVisible) {
      return null;
   }

   if (simple) {
      return (
         <div className={className}>
            <IconSpinner className={cn("inline-block animate-spin mr-2")} />
            {label && <span>{label}</span>}
         </div>
      );
   }

   if (modal) {
      return (
         <Modal
            TitleIcon={() => <IconSpinner className="h-5 w-5 animate-spin" />}
            name="Vennligst vent"
            isOpen={true}
            title="Vennligst vent"
            showCloseButton={false}
         >
            <div className="flex items-center gap-2">{label && <span>{label}</span>}</div>
         </Modal>
      );
   }

   return (
      <div className={`flex justify-center ${className}`}>
         <div className={cn("flex gap-2 text-center")}>
            <IconSpinner className={cn("animate-spin", { "w-1/12": label })} />
            {label && <span>{label}</span>}
         </div>
      </div>
   );
};

export default observer(Loading);
